import React from 'react';
import PropTypes from 'prop-types';
import { Highlight } from 'react-instantsearch/dom';
import layout from 'ck-utils/layout.module.scss';
import styles from './SearchBar.module.scss';

/**
 * Results from Collections index
 */
const SearchBarCollectionHits = ({ hits, onCollectionClick }) => (
  <>
    {hits.map((hit) => (
      <a key={hit.objectID} href={`/collections/${hit.handle}`} onClick={onCollectionClick(hit)}>
        <Highlight className={`${styles.collectionHit} ${layout.marginBottom}`} hit={hit} attribute="title" tagName="strong" />
      </a>
    ))}
  </>
);

SearchBarCollectionHits.propTypes = {
  hits: PropTypes.array.isRequired,
  onCollectionClick: PropTypes.func.isRequired
};

export { SearchBarCollectionHits };
